import {Typography} from '@mui/material';
import ArrResultTile from '../../../components/common/arr-result-tile/ArrResultTile';
import React from 'react';

const ResultTileDemo = () => {
  const tileWrapperStyle: React.CSSProperties = {
    width: 200,
    height: 200,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  };
  return (
    <div style={{gap: 24, paddingTop: 100}}>
      <Typography className="typo-text subhead1_size">
        Search Result Tiles States Demo
      </Typography>
      <div
        style={{
          marginTop: 24,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 20,
          backgroundColor: '#0C1119',
          padding: 24,
        }}
      >
        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">
            Not Selected
          </Typography>
          <ArrResultTile
            value={'2,900'}
            caption="Docs that met your criteria"
            color="#FFC37D"
          />
        </div>

        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">Selected</Typography>
          <ArrResultTile
            value={'120'}
            caption="Family Members"
            color="#00D0DB"
            type="selected"
          />
        </div>

        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">
            Not interactive tile
          </Typography>
          <ArrResultTile
            value={'2,900'}
            caption="Docs that met your criteria"
            type="inactive"
          />
        </div>

        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">
            Combined results tile
          </Typography>
          <ArrResultTile
            value={'2,900'}
            caption="Threaded Documents in Your Combined Search Results"
            type="combined"
          />
        </div>

        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">
            Run result
          </Typography>
          <ArrResultTile
            caption="Conceptually Similar"
            type="play"
            color="#FFC37D"
          />
        </div>

        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">
            With Tooltip
          </Typography>
          <ArrResultTile
            caption="Conceptually Similar"
            toolTipText="These docs did not meet your search criteria, but they do share a family relationship with at least one doc that did meet your search criteria."
            color="#FFC37D"
          />
        </div>

        <div style={tileWrapperStyle}>
          <Typography className="typo-text subhead3_size">
            Loading result
          </Typography>
          <ArrResultTile
            caption="Conceptually Similar"
            type="loading"
            color="#FFC37D"
          />
        </div>
      </div>
    </div>
  );
};

export default ResultTileDemo;
